module.exports = __webpack_public_path__ + "static/media/logo-orange-only-square.0f65a044.svg";